import type { JSX } from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { toggleFilterTypeActive } from './store/assetLibraryFilter.actions';
import { Filter } from './store/assetLibraryFilter.types';
import { AssetLibraryDispatch } from './store/assetLibraryFilter.types';
import { BombiixModal } from 'Components/BombiixModal';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';
import { ActiveIcon, InactiveIcon, SettingsIcon } from '../../../bombiix-icon';

interface FilterTypeRowProps {
  filter: Filter;
  onSettingsClick: (filterTypeId: string) => void;
  masterAddEditAccess: boolean;
}

function FilterTypeRow({ filter, onSettingsClick, masterAddEditAccess }: FilterTypeRowProps): JSX.Element {
  const dispatch = useDispatch<AssetLibraryDispatch>();
  const { t } = useTranslation('systemMaster');

  const [showToggleConfirm, setShowToggleConfirm] = useState<boolean>(false);

  const handleToggleConfirmed = (): void => {
    dispatch(toggleFilterTypeActive(filter._id, !filter.isActive, t));
    setShowToggleConfirm(false);
  };

  return (
    <>
      <li>
        <div className="asset-filter">
          <div className="input-container">
            <input type="text" maxLength={100} value={filter.label} readOnly />
          </div>
          <div className="input-action">
            {masterAddEditAccess && (
              <CustomTooltip tooltipText={t('SYSTEM_MASTER_TABLE.ACTIVE/INACTIVE')}>
                <button type="button" onClick={() => setShowToggleConfirm(true)} aria-label="Active/Inactive">
                  {filter.isActive ? <ActiveIcon size={24} className="color-green" /> : <InactiveIcon size={24} className="color-red" />}
                </button>
              </CustomTooltip>
            )}
            <CustomTooltip tooltipText={t('ASSET_LIBRARY.SETTINGS')}>
              <button type="button" onClick={() => onSettingsClick(filter._id)} aria-label="Settings">
                <SettingsIcon size={24} />
              </button>
            </CustomTooltip>
          </div>
        </div>
      </li>

      {showToggleConfirm && (
        <BombiixModal show={showToggleConfirm} title={t('ASSET_LIBRARY.ACTIVATE_DEACTIVATE')} onClose={() => setShowToggleConfirm(false)} hideSave size="md">
          <div className="bombiix-modal__confirm-body">
            <p className="mb-0 text-center">{filter.isActive ? t('ASSET_LIBRARY.CONFIRM_DEACTIVATE') : t('ASSET_LIBRARY.CONFIRM_ACTIVATE')}</p>
            <button
              type="button"
              className={`bombiix-btn ${filter.isActive ? 'btn-red' : 'btn-blue'}`}
              onClick={handleToggleConfirmed}
              data-testid="filter-type-toggle-confirm"
            >
              {filter.isActive ? t('ASSET_LIBRARY.DEACTIVATE') : t('ASSET_LIBRARY.ACTIVATE')}
            </button>
          </div>
        </BombiixModal>
      )}
    </>
  );
}

export default FilterTypeRow;
